import { useSelector } from "react-redux";

const useRoles = () => {
  const role = useSelector((state) => state.auth?.user?.role);

  return {
    readOnly: role === "READONLY",
    readWrite: role === "READWRITE",
    admin: role === "ADMIN"
  };
};

export default useRoles;
